import { render } from "./SubscriberDetail.vue?vue&type=template&id=5b49a4ca"
import script from "./SubscriberDetail.vue?vue&type=script&lang=js"
export * from "./SubscriberDetail.vue?vue&type=script&lang=js"

import "./SubscriberDetail.vue?vue&type=style&index=0&id=5b49a4ca&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__